import { DialogTrigger, Dialog, Modal } from 'react-aria-components';

import Button from '@/components/Button/Button';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onShare?: () => void;
  isDraft?: boolean;
};

export const ShareConfirmDialog = ({ isOpen, setIsOpen, onShare, isDraft }: Props) => {
  const handleConfirm = () => {
    setIsOpen(false);
    if (onShare) {
      onShare();
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[500px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <div className="flex flex-col gap-6">
            <div className="text-center">
              <h2 className="text-lg font-semibold text-gray-900">利用者へ共有</h2>
            </div>

            <div className="text-center text-gray-700">
              <p>{`保護者に個別支援計画${isDraft ? '（案）' : ''}を共有してもよろしいですか？`}</p>
            </div>

            <div className="flex flex-col items-center justify-center space-y-2">
              <Button
                type="button"
                size="lg"
                variant="solid-fill"
                onClick={handleConfirm}
              >
                共有する
              </Button>
              <Button
                type="button"
                size="lg"
                variant="text"
                onClick={handleCancel}
              >
                キャンセル
              </Button>
            </div>
          </div>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
